export const company =
{
    name: 'Property Pros Pattaya',
    welcomeName: 'propertypropspattaya.com',
    mainServiceArea: 'Pattaya',
    phone1: '+66 (0) 65 550 1642',
    navPhone: '+66 (0) 65 550 1642',
    email: 'propertypros.pn@gmail.com',
    address1: '79/6 Moo 13 Nong Prue',
    address2: 'Pattaya, Thailand',
    phoneUrl: 'tel:+66655501642',
    lineUrl: 'https://line.me/ti/p/',
    whatsappUrl: 'https://wa.me/66655501642',
    facebookUrl: 'https://www.facebook.com/Ciyawinner',
    instagramUrl: 'https://www.instagram.com',
    linkedInUrl: 'https://www.linkedin.com/company/',
    // tiktokUrl: 'https://www.tiktok.com/@remaxsamui',
    // youtubeUrl: 'https://www.youtube.com/@remaxislandrealestate8644',
}
